import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const DURUM_RENK: Record<string, string> = { 'Bekliyor': '#94a3b8', 'Kütükte': '#3b82f6', "CNC'de": '#a855f7', 'Tamamlandı': '#22c55e', 'Red': '#ff4d4f', 'Hurda': '#434343' };

@Component({
  selector: 'cam-parca-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#0891b2">
      <div class="sk-icerik">
        <div class="sk-baslik">🔷 {{ d('parcaAdi') || 'İsimsiz Parça' }}</div>
        @if (d('malzeme')) { <div class="sk-alt">{{ d('malzeme') }}</div> }
        @if (olcu()) { <div class="sk-alt" style="font-family:monospace;font-size:10px">{{ olcu() }}</div> }
      </div>
      <div class="sk-sag">
        @if (d('adet')) { <span style="font-size:12px;font-weight:600;color:var(--py-metin,#333)">{{ d('adet') }} ad.</span> }
        <span class="sk-chip" [style.border-color]="durumRenk()" [style.color]="durumRenk()">{{ sonDurum() }}</span>
      </div>
    </div>
  `,
})
export class CamParcaKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
  olcu = computed(() => { const v = [this.d('en'), this.d('boy'), this.d('yukseklik')].filter(x => x); return v.length ? v.join(' × ') + ' mm' : ''; });
  sonDurum = computed(() => this.d('durum') || 'Bekliyor');
  durumRenk = computed(() => DURUM_RENK[this.sonDurum()] || '#94a3b8');
}
